import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'

/**
 * Basic component to provide a styling and responsiveness wrapper around the
 * calculator sections
 */
export default class CalcSection extends Component {
  render () {
    const titleStyle = {
      paddingLeft: 10,
      paddingRight: 10
    }

    const titleTextStyle = {
      fontWeight: 'normal',
      color: '#00B084',
      textAlign: 'left',
      fontFamily: 'Italianno, cursive',
      zIndex: 10,
      textShadow: '2px 2px 4px rgba(150, 150, 150, 1)'
    }

    const whiteSectionColor = {
      backgroundColor: 'white'
    }

    const contentStyle = {
      paddingLeft: 30,
      paddingRight: 20,
      paddingBottom: 30
    }

    return (
      <div style={whiteSectionColor}>
        <Row style={titleStyle} className='sectionTitle'>
          <Col xs={0} sm={1} />
          <Col xs={12} sm={10} md={8} lg={7}>
            <div style={titleTextStyle}>{this.props.title}</div>
          </Col>
          <Col xs={0} sm={1} md={3} lg={4} />
        </Row>
        <Row style={contentStyle}>
          <Col xs={0} sm={1} />
          <Col xs={12} sm={10} md={8} lg={7}>
            {this.props.children}
          </Col>
          <Col xs={0} sm={1} md={3} lg={4} />
        </Row>
      </div>
    )
  }
}

CalcSection.propTypes = {
  title: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/CalcSection.js